import React from 'react'
import './Home.css'
import Product from './Product'

function Home() {
  return (
    <div  className='home'>
      <img src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/launch/gateway/TheUndergroundRailroad/UGRR_S1_GWBleedingHero_ENG_COVIDUPDATE_XSite_1500X600_PV_en-GB._CB669781769_.jpg" alt="" className='home__image'/>
    
    <div className="home__row">
    <Product id="12345"
    title="The South Beach Diet: The Delicious, Doctor-Designed, Foolproof Plan for Fast and Healthy Weight Loss"
    price={499}
    rating={5}
    image="https://images-na.ssl-images-amazon.com/images/I/51nBFGbVg9L._SX302_BO1,204,203,200_.jpg"
    />

    <Product id="12346"
    title="Samsung Galaxy M53 5G (Mystique Green, 8GB, 128GB Storage) | Travel Adapter to be Purchased Separately"
    price={15000}
    rating={4}
    image="https://images-eu.ssl-images-amazon.com/images/I/31jFAvjA3gL._SY300_SX300_QL70_FMwebp_.jpg"
    />

</div>
<div className="home__row">
  <Product id="12347"
    title="Noise ColorFit Pulse Grand Smart Watch with 1.69 HD Display, 60 Sports Modes, 150 Watch Faces, Fast Charge, Spo2 Monitoring Smartwatches for Men"
    price={5000}
    rating={3}
    image="https://m.media-amazon.com/images/I/61pFWFaGy3L._SX679_.jpg"
    />


    <Product id="12348"
    title="ASUS VivoBook 14 (2021), 14-inch (35.56 cms) FHD, Intel Core i7-1065G7 10th Gen, Thin and Light Laptop"
    price={34000}
    rating={5}
    image="https://m.media-amazon.com/images/I/71WuDXpTAlL._AC_UL480_QL65_.jpg"
    />


    <Product id="12349"
    title="Echo Dot (3rd Gen), Certified Refurbished, Black – Improved smart speaker with Alexa – Like new, backed with 1-year warranty"
    price={8000}
    rating={4}
    image="https://m.media-amazon.com/images/I/61EXU8BuGZL._AC_UY327_FMwebp_QL65_.jpg"
    />
</div>

<div className="home__row">
  <Product id="12340"
    title="LG UltraWide 73 cm (29 Inches) WFHD (2560 x 1080) IPS Display - HDR 10, AMD Freesync, Inbuilt 5W Speaker, sRGB 99%, Multi Tasking Monitor, HDMI X 2, Made in India - 29WL50S, Black"
    price={11.98}
    rating={3}
    image="https://m.media-amazon.com/images/I/61dVD28WPrL._SX679_.jpg"
    />
</div>

    </div>
  )
}

export default Home
